 <template>
  <div>
    <Drawer :mask-closable="false" @on-close="handleReset('companyRegistrationForm')" class="demo-drawer-prime"
            title="Register Company"
            v-model="$parent.editCompanyDrawer" width="620">
      <Row>
        <Col style="padding-top: 10px">
          <!--<ApolloMutation :mutation="mutation_ADD_COMPANY"
                          :variables="{email:companyRegistrationForm.email ,gstin:companyRegistrationForm.gstin.toString(),
                        id:generateUUID(), mobile:companyRegistrationForm.mobile.toString(),address:addressArr,
                        name:companyRegistrationForm.name, type:companyRegistrationForm.userType, routes:companyRegistrationForm.routes }"
                          @done="afterAddCompany">
            <template slot-scope="{ mutate, loading, error }">
              <Modal :loading="otpLoading" @keypress.enter="confirmOTP('otpForm',mutate)"
                     @on-cancel="clearOTP('otpForm')"
                     @on-ok="confirmOTP('otpForm',mutate)"
                     title="Enter OTP" v-model="otpModal" width="360">
                <Form :model="otpForm" :rules="otpRuleValidate" label-position="top" ref="otpForm">
                  <Row>
                    <Col offset="5" span="14">
                      <p>Enter OTP Sent to <strong>{{companyRegistrationForm.mobile}}.</strong></p>
                      <FormItem prop="otp">
                        <Input :maxlength="4" number placerholder="Enter OTP" v-model="otpForm.otp"></Input>
                      </FormItem>
                    </Col>
                  </Row>
                </Form>
              </Modal>
              <p v-if="error">An error occured: {{ error }}</p> -->
              <Form :model="companyRegistrationForm" :rules="companyRuleValidate" label-position="top"
                    ref="companyRegistrationForm">
                <Card shadow title="Company Detail">
                  <template slot="extra" v-if="!$parent.addToAddressBookOnly">
                    <FormItem prop="isApproved">
                      <i-switch v-model="companyRegistrationForm.isApproved" title="Status" :style="companyRegistrationForm.isApproved?'background: green':'background: red'"/>
                    </FormItem>
                  </template>
                  <FormItem label="I am a" prop="userType">
                    <ApolloQuery :query="query_GET_COMPANY_TYPE" :skip="companyType_skip">
                      <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else-if="data">
                          <div style="display: none;">{{$parent.companyType = data.type}}</div>
                          <Select v-model="companyRegistrationForm.userType">
                            <template v-for="companyType in data.type">
                              <OptionGroup :label="companyType.name" v-if="companyType.parentId===null">
                                <Option :key="index" :value="companyTypeTemp.id"
                                        v-for="(companyTypeTemp,index) in data.type"
                                        v-if="companyTypeTemp.type===companyType.type">{{ companyTypeTemp.name }}
                                </Option>
                              </OptionGroup>
                            </template>
                          </Select>
                        </div>
                        <div v-else>
                          There are no Companies Available yet.
                        </div>
                      </template>
                    </ApolloQuery>
                  </FormItem>
                  <Row :gutter="32">
                    <Col span="12">
                      <FormItem label="Company Name" prop="name">
                        <Input placeholder="Enter your Company" v-model="companyRegistrationForm.name"></Input>
                      </FormItem>
                    </Col>
                    <Col span="12">
                      <FormItem label="Registered Email" prop="email">
                        <Input placeholder="Search Email" v-model="companyRegistrationForm.email"></Input>
                      </FormItem>
                    </Col>
                  </Row>
                  <Row :gutter="32">
                    <Col span="12">
                      <FormItem label="Mobile" prop="mobile">
                        <Input :maxlength="10" number placeholder="Enter your Mobile"
                               v-model="companyRegistrationForm.mobile"></Input>
                      </FormItem>
                    </Col>
                    <Col span="12">
                      <FormItem label="GSTIN" prop="gstin">
                        <Input :maxlength="15" class="capitalize-gstin" placeholder="Enter your GSNTIN"
                               v-model="companyRegistrationForm.gstin"></Input>
                      </FormItem>
                    </Col>
                  </Row>
                  <Divider></Divider>

                  <!-- -------------------- Addresses section ------------------- -->
                  <Row>
                    <h3>Addresses
                      <Button @click="addAddressDrawer=true" icon="ios-add" shape="circle" type="primary"></Button>
                    </h3>
                  </Row>
                  <Divider></Divider>
                  <Row v-if="addressArr.length">
                    <Col :key="index" span="24" v-for="(address, index) in addressArr">
                      <Card>
                        <p slot="title">Address {{index+1}}</p>
                        <p>{{getAddressString(address)}}</p>
                      </Card>
                    </Col>
                  </Row>
                  <Row v-else>No Address added yet</Row>
                  <!-- ------x-------x-------x-------x-------x--------x-------- -->
                  <Divider></Divider>
                  <template v-if="!$parent.addToAddressBookOnly">
                  <!-- -------------------- CompanyUsers section ------------------- -->
                  <Row>
                    <h3>Company Users
                      <Button @click="addCompanyUserDrawer=true" icon="ios-add" shape="circle" type="primary"></Button>
                    </h3>
                  </Row>
                  <Divider></Divider>
                  <Row v-if="companyUsers.length">
                    <Col :key="index" span="24" v-for="(user, index) in companyUsers">
                      <Card>
                        <p slot="title">User {{index+1}}
                          <Icon style="float: right" type="md-close" @click.stop="removeCompanyUser(index)"></Icon>
                          <Icon style="float: right;margin-right: 5px" type="md-create" @click.stop="onEditCompanyUser(user, index)"></Icon></p>
                        <Row>
                          <!--                                <Col span="10">Role</Col>-->
                          <!--                                <Col span="14">{{user.role == 1 ? 'Marketing' : 'Dispatch'}}</Col>-->
                          <Col span="10">Name</Col>
                          <Col span="14">{{user.name}}</Col>
                          <Col span="10">Mobile</Col>
                          <Col span="14">{{user.mobile}}</Col>
                          <Col span="10">Email</Col>
                          <Col span="14">{{user.email}}</Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                  <Row v-else>No Company Users added yet</Row>
                  <!-- ------x-------x-------x-------x-------x--------x-------- -->
                  <Divider></Divider>
                  <!-- -------------------- Contacts section ------------------- -->
                  <Row>
                    <h3>Contacts
                      <Button @click="addContactDrawer=true" icon="ios-add" shape="circle" type="primary"></Button>
                    </h3>
                  </Row>
                  <Divider></Divider>
                  <Row v-if="contactArr.length">
                    <Col :key="index" span="24" v-for="(contact, index) in contactArr">
                      <Card>
                        <p slot="title">Contact {{index+1}}</p>
                        <Row>
                          <Col span="10">Role</Col>
                          <Col span="14">{{contact.role == 1 ? 'Marketing' : 'Dispatch'}}</Col>
                          <Col span="10">Name</Col>
                          <Col span="14">{{contact.name}}</Col>
                          <Col span="10">Mobile</Col>
                          <Col span="14">{{contact.mobile}}</Col>
                          <Col span="10">Email</Col>
                          <Col span="14">{{contact.email}}</Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                  <Row v-else>No Contact added yet</Row>
                  <!-- ------x-------x-------x-------x-------x--------x-------- -->
                  <!-- -------------------- Routes section ------------------- -->
                  <template v-if="companyRegistrationForm.userType === Constants.companyType.transporter">
                    <Divider></Divider>
                    <Row><h3>Routes</h3></Row>
                    <Divider></Divider>
                    <FormItem prop="routes">
                      <template v-for="(i, index) in numOfRoutes">
                        <AutoComplete v-model="routes_fromCity[index]" style="width: 45%;margin:0 10px 5px 0"
                                      @on-search="handleCitySearch" @on-focus="routeCityFilter='%%'" placement="top">
                          <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                                  :key="index" :value="cityObj.city">
                            <div class="ivu-select-item-div">{{cityObj.city}}</div>
                          </Option>
                        </AutoComplete>
                        <AutoComplete v-model="routes_toCity[index]" style="width: 45%;margin:0 5px 5px 0"
                                      @on-search="handleCitySearch" @on-focus="routeCityFilter='%%'" placement="top">
                          <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                                  :key="index" :value="cityObj.city">
                            <div class="ivu-select-item-div">{{cityObj.city}}</div>
                          </Option>
                        </AutoComplete>
                        <Icon type="md-add-circle" size="22" v-if="index===0" @click="numOfRoutes++"/>
                      </template>
                    </FormItem>
                  </template>
                  <!-- ------x-------x-------x-------x-------x--------x-------- -->
                  </template>

                  <FormItem style="text-align: right">
                    <Button :loading="companyLoading" @click="handleSubmit('companyRegistrationForm')" type="primary">Submit
                    </Button>
                    <Button @click="handleReset('companyRegistrationForm')" style="margin-left: 8px" type="error">Reset
                    </Button>
                  </FormItem>
                </Card>
              </Form>

            <!--</template>
          </ApolloMutation> -->
        </Col>
      </Row>
    </Drawer>
    <Drawer :mask-closable="false" @on-close="handleReset('addressForm')" title="Add Address"
            v-model="addAddressDrawer" width="620">
      <Row>
        <Col span="24">
          <Form :model="addressForm" :rules="addressRuleValidate" label-position="top" ref="addressForm">
            <Row :gutter="32">
              <Col span="12">
                <FormItem label="Address 1" prop="add1">
                  <Input placeholder="Enter your Address" v-model="addressForm.add1"></Input>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="Address 2" prop="add2">
                  <Input placeholder="Enter your Address" v-model="addressForm.add2"></Input>
                </FormItem>
              </Col>
            </Row>
            <Row :gutter="32">
              <Col span="12">
                <FormItem label="City" prop="city" v-if="addAddressDrawer">
                  <ApolloQuery :query="$parent.addToAddressBookOnly?query_EXCEPTIONAL_CITY_MANAGER_SEARCH_CITY:query_SEARCH_CITY"
                     :variables="{cityFilter}">    <!-- Show all Cities While add company in PlaceOrderForm irrespective of Role-->
                    <template slot-scope="{ result: { loading, error, data } }">
                      <div v-if="loading"> Loading...</div>
                      <div v-else-if="error"> Error Occured. {{error}}</div>
                      <div v-else-if="data">
                        <AutoComplete placeholder="Search City"
                                      v-model="addressForm.city">
                          <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data.city">
                            <div @click="addressForm.state=cityObj.state;selectedCityId=cityObj.id">{{cityObj.city}}</div>
                          </Option>
                        </AutoComplete>
                      </div>
                      <div v-else>
                        There are no City Available yet.
                      </div>
                    </template>
                  </ApolloQuery>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="State" prop="state" v-if="addAddressDrawer">
                  <ApolloQuery :query="query_SEARCH_STATE" :variables="{stateFilter}">
                    <template slot-scope="{ result: { loading, error, data } }">
                      <div v-if="loading"> Loading...</div>
                      <div v-else-if="error"> Error Occured. {{error}}</div>
                      <div v-else-if="data">
                        <AutoComplete placeholder="Search State"
                                      v-model="addressForm.state">
                          <Option :key="index" :value="stateObj.state" v-for="(stateObj,index) in data.territories">
                            {{stateObj.state}}
                          </Option>
                        </AutoComplete>
                      </div>
                      <div v-else>
                        There are no State Available yet.
                      </div>
                    </template>
                  </ApolloQuery>
                </FormItem>
              </Col>
            </Row>
            <Row :gutter="32">
              <Col span="12">
                <FormItem label="Area" prop="area">
                  <Select v-model="addressForm.area" filterable>
                    <Option v-for="(area,index) in areaArr" :value="area.area"
                            :label="area.area" :key="index">
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem label="PIN" prop="pincode">
                  <Input type="number" placeholder="Enter your PIN" v-model="addressForm.pincode"></Input>
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <Button @click="handleAddAddress()" color="primary">Add</Button>
    </Drawer>
    <Drawer :mask-closable="false" @on-close="handleReset('contactForm')" title="Add Contact"
            v-model="addContactDrawer" width="620">
      <Row>
        <Col span="24">
          <Form :model="contactForm" :rules="contactRuleValidate" label-position="top" ref="contactForm">
            <FormItem label="Type" prop="type">
              <RadioGroup v-model="contactForm.role">
                <Radio label="1"><span>Marketing</span></Radio>
                <Radio label="2"><span>Dispatch</span></Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="Contact Name" prop="name">
              <Input :maxlength="30" v-model="contactForm.name"/>
            </FormItem>
            <FormItem label="Mobile Number" prop="mobile">
              <Input type="number" v-model="contactForm.mobile"/>
            </FormItem>
            <FormItem label="Email" prop="email">
              <Input v-model="contactForm.email"/>
            </FormItem>
          </Form>
        </Col>
      </Row>
      <Button @click="handleAddContact()" color="primary">Add</Button>
    </Drawer>
    <Drawer :mask-closable="false" @on-close="handleReset('companyUserForm')" title="Add Company User"
            v-model="addCompanyUserDrawer" width="620">
      <Row>
        <Col span="24">
          <Form :model="companyUserForm" :rules="companyUserRuleValidate" label-position="top" ref="companyUserForm">
            <!--                    <FormItem label="Type" prop="type">-->
            <!--                        <RadioGroup v-model="companyUserForm.role">-->
            <!--                            <Radio label="1"><span>Marketing</span></Radio>-->
            <!--                            <Radio label="2"><span>Dispatch</span></Radio>-->
            <!--                        </RadioGroup>-->
            <!--                    </FormItem>-->
            <FormItem label="User Name" prop="name">
              <Input :maxlength="30" v-model="companyUserForm.name"/>
            </FormItem>
            <FormItem label="Mobile Number" prop="mobile">
              <Input type="number" v-model="companyUserForm.mobile"/>
            </FormItem>
            <FormItem label="Email" prop="email">
              <Input v-model="companyUserForm.email"/>
            </FormItem>
          </Form>
        </Col>
      </Row>
      <Button @click="handleAddCompanyUser()" color="primary">Add</Button>
    </Drawer>
  </div>
</template>

<script>
    import ValidationRules from '../Constants/ValidationRules'
    import { GET_COMPANY_TYPE } from '../graphql/queries/companies'
    import { ADD_COMPANY, ADD_COMPANY_TO_ADDRESSBOOK } from '../graphql/mutations/companies'
    import { SEND_OTP } from '../graphql/mutations/sendOtp'
    import {ADD_COMPANY_USER, ADD_CONTACT, ADD_CONTACT_TO_ADDRESSBOOK} from '../graphql/mutations/contacts'
    import { VERIFY_OTP } from '../graphql/queries/sendOtp'
    import {EXCEPTIONAL_CITY_MANAGER_SEARCH_CITY2, SEARCH_CITY2, SEARCH_STATE} from '../graphql/queries/territories'
    import {GET_AREAS_BY_CITY} from '../graphql/queries/area'
    import {Constants, generateUUID} from "../Constants/Constant";
    import {GET_COMPANY_USER_BY_MOBILE} from "../graphql/queries/contacts";
    import {getAddressString} from "./ExcelFormattedOrders/RendererFunctions";

    export default {
        apollo: {
            area: {
                query: GET_AREAS_BY_CITY,
                variables() {
                    return {
                        cityId: this.selectedCityId,
                    }
                },
                result({data, loading}) {
                    if (!loading) {
                        this.areaArr = data.area;
                    }
                }
            },
            city: {
              query: SEARCH_CITY2,
              variables() { return { cityFilter: this.routeCityFilter }},
              result ({ data, loading }) {
                if (!loading) { this.cityArr = data.city }
              }
            },
        },
        name: 'RegisterCompanyDrawer',
        props: ['initialCompanyType'],
        data () {
            let self = this
            return {
                query_GET_COMPANY_TYPE: GET_COMPANY_TYPE,
                query_SEARCH_CITY: SEARCH_CITY2,
                query_EXCEPTIONAL_CITY_MANAGER_SEARCH_CITY: EXCEPTIONAL_CITY_MANAGER_SEARCH_CITY2,
                query_SEARCH_STATE: SEARCH_STATE,
                mutation_ADD_COMPANY: ADD_COMPANY,
                mutation_ADD_COMPANY_TO_ADDRESSBOOK: ADD_COMPANY_TO_ADDRESSBOOK,
                mutation_ADD_CONTACT: ADD_CONTACT,
                mutation_ADD_CONTACT_TO_ADDRESSBOOK: ADD_CONTACT_TO_ADDRESSBOOK,
                Constants: Constants,
                otpForm: {
                    otp: ''
                },
                otpRuleValidate: {
                    otp: ValidationRules.otp
                },
                companyRegistrationForm: {
                    userType: '',
                    name: '',
                    email: '',
                    mobile: '',
                    companyName: '',
                    registeredMobile: '',
                    registeredEmail: '',
                    gstin: '',
                    routes: [],
                    isApproved: true
                },
                companyRuleValidate: {
                    userType: ValidationRules.userType, name: ValidationRules.name,
                    email: ValidationRules.email, mobile: ValidationRules.mobile,
                    gstin: ValidationRules.gstin
                },
                mobiles: [],
                emails: [],
                companyLoading: false,
                otpLoading: true,
                otpModal: false,
                otpUniqueId: '',
                addAddressDrawer: false,
                addressForm: {
                    add1: '',
                    add2: '',
                    area: '',
                    pincode: null,
                    city: null,
                    state: null
                },
                addressRuleValidate: {
                    add1: ValidationRules.add2, area: ValidationRules.area,
                    city: ValidationRules.city, state: ValidationRules.state
                },
                addressArr: [],
                addContactDrawer: false,
                contactForm: {
                    role: '1',
                    name: '',
                    mobile: '',
                    email: ''
                },
                contactRuleValidate: {
                    name: [{ required: true, message: 'Enter name', trigger: 'blur' }],
                    email: [{ type: 'email', message: 'Incorrect email format', trigger: 'change' }],
                    mobile: [{ validator: self.validateMobile, trigger: 'change' }]
                },
                contactArr: [],
                companyUsers: [],
                addCompanyUserDrawer: false,
                companyUserForm: {
                  role: '1',
                  name: '',
                  mobile: '',
                  email: ''
                },
                companyUserRuleValidate: {
                  name: [{ required: true, message: 'Enter name', trigger: 'blur' }],
                  email: [{ type: 'email', message: 'Incorrect email format', trigger: 'change' }],
                  mobile: [{ validator: self.validateMobile, trigger: 'change' }]
                },
                editIndex: null,
                companyType_skip: true,
                selectedCityId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                areaArr: [],
                getAddressString: getAddressString,
                cityArr: [],
                numOfRoutes: 1,
                routes_fromCity: {},
                routes_toCity: {},
                routeCityFilter: '%%',
            }
        },
        computed: {
            cityFilter () {
                return '%' + this.addressForm.city + '%'
            }, stateFilter () {
                return '%' + this.addressForm.state + '%'
            },
        },
        mounted () {
            document.addEventListener('keypress', this.addEventListener)
        },
        methods: {
            generateUUID () {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
                    return v.toString(16)
                })
            },
            validateMobile (rule, value, callback) {
                if (value && value.toString().length !== 10) {
                    callback(new Error('Length Must be equal to 10 digit'))
                } else {
                    callback()
                }
            },
            handleCitySearch: _.debounce(function(val){
              this.routeCityFilter = '%' + val + '%'
            }, 500),
            async handleSubmit (name) {
              if(this.companyUsers.length){
                  let arr = this.companyUsers.map((usr) => usr.mobile);
                  let uniqueDuplicates = [...new Set(arr.filter((item, index) => arr.indexOf(item) != index))];
                  if(uniqueDuplicates.length){
                    this.$Message.info({content: 'Company Users - Duplicate Numbers found ! <br>'+uniqueDuplicates.join(",  ") ,
                                               duration: 10, closable: true});
                    return;
                  }
                this.companyLoading = true
                let response = await this.$apollo.query({
                  query: GET_COMPANY_USER_BY_MOBILE,
                  variables: {
                    mobileArr: arr,
                  }
                })
                if(response.data.companyUsers.length){
                  uniqueDuplicates = response.data.companyUsers.map((usr) => usr.mobile);
                  this.$Message.info({content: 'Company Users - Mobile already exists ! <br>'+uniqueDuplicates.join(",  ") ,
                    duration: 10, closable: true});
                  this.companyLoading = false
                  return ;
                }

              }

                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if (this.addressArr.length) {
                            /* ------------- Avoid OTP Verification ------------------- */
                            // this.sendOTP()
                            if (!this.$parent.addToAddressBookOnly) {
                                this.addCompany()            /* mutate() */
                            } else{
                                this.addCompanyToAddressBook()
                            }

                            /* ---------x----------x------------x----------x----------- */
                        } else {
                            this.$Message.error('Please enter atleast one address!')
                        }
                    } else {
                        this.$Message.error('Check Details!')
                    }
                })
            },
            async sendOTP () {
                let response = await
                    this.$apollo.mutate({
                        mutation: SEND_OTP,
                        variables: { mobile: this.companyRegistrationForm.mobile, uniqueId: this.generateUUID() }
                    })
                this.otpUniqueId = response.data.insert_sendOtp.returning[0].uniqueId
                this.otpModal = true
            },
            clearOTP (name) {
                this.otpForm.otp = ''
                this.$refs[name].resetFields()
            },
            async confirmOTP (name, mutate) {
                let formValid = false
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        formValid = true
                    } else {
                        formValid = false
                        this.$Message.error('Check OTP Format')
                    }
                })
                if (formValid) {
                    let response = await this.$apollo.query({
                        query: VERIFY_OTP,
                        variables: { otp: this.otpForm.otp, uniqueId: this.otpUniqueId }
                    })
                    if (response.data.sendOtp.length) {
                        this.otpModal = false
                        if (!this.$parent.addToAddressBookOnly) {
                            mutate()
                        }
                        this.addCompanyToAddressBook()
                    } else {
                        formValid = false
                        this.otpLoading = false
                        this.$Message.error('OTP Verification Failed')
                    }
                }
            },
            async addCompanyToAddressBook (clientId) {
                let self = this
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_COMPANY_TO_ADDRESSBOOK,
                    variables: {
                        id: this.generateUUID(),
                        name: self.companyRegistrationForm.name,
                        type: self.companyRegistrationForm.userType,
                        mobile: self.companyRegistrationForm.mobile.toString(),
                        email: self.companyRegistrationForm.email,
                        gstin: self.companyRegistrationForm.gstin.toString(),
                        address: self.addressArr,
                        parentCompanyId: clientId?clientId:null,
                        isApproved: this.companyRegistrationForm.isApproved,
                    }
                })
                if (response.data.insert_addressbookedcompany.returning[0].id) {
                    let clientId = response.data.insert_addressbookedcompany.returning[0].id
                    if (this.$parent.addToAddressBookOnly) {
                        this.$Message.success('Company Registered Successfully.')
                        this.$refs['companyRegistrationForm'].resetFields()
                        this.$refs['otpForm'].resetFields()
                    }
                    self.contactArr.forEach(function (curnt, index) {
                        self.addContactToAddressBook(curnt, clientId, index)
                    })
                }
            },
             async addCompany(){
                let routes = []
                for(let i=0; i<this.numOfRoutes; i++){
                  if(this.routes_fromCity[i] && this.routes_toCity[i]) routes.push({fromCity: this.routes_fromCity[i], toCity: this.routes_toCity[i]})
                }
                this.companyRegistrationForm.routes = this.companyRegistrationForm.userType === Constants.companyType.transporter? routes : null

                let response = await this.$apollo.mutate({
                    mutation: ADD_COMPANY,
                    variables: {
                        id: this.generateUUID(),
                        name: this.companyRegistrationForm.name,
                        type: this.companyRegistrationForm.userType,
                        mobile: this.companyRegistrationForm.mobile.toString(),
                        email: this.companyRegistrationForm.email,
                        gstin: this.companyRegistrationForm.gstin.toString(),
                        address: this.addressArr,
                        routes: this.companyRegistrationForm.routes,
                        isApproved: this.companyRegistrationForm.isApproved,
                        isRejected: !this.companyRegistrationForm.isApproved,
                    }
                })
                if (response.data) this.afterAddCompany(response)
            },
            afterAddCompany (response) {
                let self = this
                let clientId = response.data.insert_company.returning[0].id
        /* ----------- Insert company in AddressBook after inserting in main Company table --------- */
                this.addCompanyToAddressBook(clientId)
        /* ---------------x--------------x--------------x----------------x----------------x---------- */
                this.$Message.success('Company Registered Successfully.')
                this.$refs['companyRegistrationForm'].resetFields()
                /*this.$refs['otpForm'].resetFields()*/
                if(this.companyUsers.length){this.addCompanyUsers(clientId)}
                this.contactArr.forEach(function (curnt, index) {
                    self.addContact(curnt, clientId, index)
                })
                this.numOfRoutes = 1;                     //Reset
                this.routes_fromCity = {};                //Reset
                this.routes_toCity = {};                  //Reset
                this.companyLoading = false
            },
            async addCompanyUsers (clientId) {
              this.companyUsers.forEach((user) => {
                user.id = generateUUID();
                user.clientid = clientId;
                user.mobile = user.mobile.toString();
                user.role = Number(user.role);
              });
              let object = [...this.companyUsers];

              let response = await this.$apollo.mutate({
                mutation: ADD_COMPANY_USER,
                variables: {
                  object: object
                }
              })

            },
            async addContact (contactObj, clientId, index) {
                let self = this
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_CONTACT,
                    variables: {
                        id: this.generateUUID(),
                        name: contactObj.name,
                        mobile: contactObj.mobile,
                        email: contactObj.email,
                        role: parseInt(contactObj.role),
                        clientid: clientId
                    }
                })
                if (response.data.insert_contacts.returning[0].id) {
                }
            },
            async addContactToAddressBook (contactObj, clientId, index) {
                let self = this
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_CONTACT_TO_ADDRESSBOOK,
                    variables: {
                        id: this.generateUUID(),
                        name: contactObj.name,
                        mobile: contactObj.mobile,
                        email: contactObj.email,
                        role: parseInt(contactObj.role),
                        clientid: clientId
                    }
                })
                if (response.data.insert_addressbookedcontacts.returning[0].id) {
                    if (index === (self.contactArr.length - 1)) {
                        this.$Message.success('Contact added Successfully!')
                        this.$parent.editCompanyDrawer = false
                    }
                }
            },
            handleReset (name) {
                this.$refs[name].resetFields()
                this.editIndex = null
                if (name == 'companyRegistrationForm') {
                    this.addressArr = []
                    this.contactArr = []
                    this.companyUsers = []
                    this.numOfRoutes = 1;
                    this.routes_fromCity = {};
                    this.routes_toCity = {};
                }
            },
            addEventListener (event) {
                if (event.key === 'Enter') {
                    if (this.otpModal) {

                    } else {
                        this.handleSubmit('companyRegistrationForm')
                    }
                }
            },
            handleAddAddress () {
                this.$refs['addressForm'].validate((valid) => {
                    if (valid) {
                        let addressObj = Object.assign({}, this.addressForm)
                        this.addressArr.push(addressObj)
                        this.handleReset('addressForm')
                        this.addAddressDrawer = false
                    } else {
                        this.$Message.error('Fail to add Address')
                    }
                })
            },
            handleAddContact () {
                this.$refs['contactForm'].validate((valid) => {
                    if (valid) {
                        let contactObj = Object.assign({}, this.contactForm)
                        this.contactArr.push(contactObj)
                        this.handleReset('contactForm')
                        this.addContactDrawer = false
                    } else {
                        this.$Message.error('Fail to add Contact')
                    }
                })
            },
            handleAddCompanyUser () {
              this.$refs['companyUserForm'].validate((valid) => {
                if (valid) {
                  let companyUserObj = Object.assign({}, this.companyUserForm)
                  /* --------- When edit/update user ----------- */
                  if(this.editIndex !== null){
                    this.companyUsers.splice(this.editIndex, 1)
                  }
                  /* ----------x--------------x-----------x--------- */
                  this.companyUsers.push(companyUserObj)
                  this.handleReset('companyUserForm')
                  this.addCompanyUserDrawer = false
                } else {
                  this.$Message.error('Fail to add user')
                }
              })
          },
            removeCompanyUser(index){
              this.companyUsers.splice(index, 1)
            },
            onEditCompanyUser(user, index){
              this.companyUserForm.role = user.role.toString()
              this.companyUserForm.name = user.name
              this.companyUserForm.email = user.email
              this.companyUserForm.mobile = parseInt(user.mobile)
              this.editIndex = index
              this.addCompanyUserDrawer = true
            },
        },
        watch: {
            'initialCompanyType' (val) {
                this.companyRegistrationForm.userType = val
            },
        }
    }
</script>

<style scoped>
  .demo-drawer-prime {
    height: calc(100% - 55px);
    overflow: auto;
    paddingBottom: 53px;
    position: static;
  }

  .capitalize-gstin input {
    text-transform: uppercase;
  }
</style>
